// import { useState } from "react";
import { useHistory } from "react-router";
import { useUser } from "../../../providers/UserContext";

import { ContainerFooter, ContainerTools, ContainerMenu } from "./style";

const ButtonsMap = ({ showButtons = true }) => {
  const history = useHistory();

  const { Logout } = useUser()

  return (
    <ContainerFooter>
      {showButtons && (
        <ContainerTools>
          <button onClick={() => history.push("/mpStockSausage")}>
            <img src="./images/stock_Mp.svg" alt="purchase_button" />
          </button>
          <button onClick={() => history.push("/mpPurchasesSausage")}>
            <img src="./images/purchase_button.svg" alt="production_button" />
          </button>
          <button onClick={() => history.push("mpSalesSausage")}>
            <img src="./images/partnership.svg" alt="commercial_button" />
          </button>
          {/* <button onClick={() => history.push("weeklyReportStock")}>
            <img src="./images/calendar.svg" alt="pcp_button" />
          </button> */}
        </ContainerTools>
      )}
      <ContainerMenu>
        <button onClick={() => history.push("/mLossesAndProfits")}>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <img src="./images/pel_button.svg" alt="pel_button.svg" />
            <p
              style={{
                marginLeft: "5px",
                color: '#fff'
              }}
            >Lucros e Perdas</p>
          </div>
        </button>
        <button onClick={() => history.push("/mCashFlow")}>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <img src="./images/cash_flow.svg" alt="cash flow" />
            <p
              style={{
                marginLeft: "5px",
                color: '#fff'
              }}
            >Caixa</p>
          </div>
        </button>
        <button onClick={() => history.push("/mBank")}>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <img src="./images/bank_button.svg" alt="bank_button" />
            <p
              style={{
                marginLeft: "5px",
                color: '#fff'
              }}
            >Banco</p>
          </div>
        </button>
        {/* <button onClick={() => history.push("/mConsultancy")}>
          <img src="./images/consultancy_button.svg" alt="consultancy_button" />
        </button> */}
        <button onClick={() => {
          Logout()
          history.push("/mapMaketplace")
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <img src="/images/back_button.svg" alt="back_button" />
            <p
              style={{
                marginLeft: "5px",
                color: '#fff'
              }}
            >Sair</p>
          </div>
        </button>
      </ContainerMenu>
    </ContainerFooter>
  );
};
export default ButtonsMap;
